document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-engraved-faq]');

  faqSections.forEach((section) => {
    const items = section.querySelectorAll('[data-engraved-faq-item]');

    items.forEach((item) => {
      const trigger = item.querySelector('[data-engraved-faq-trigger]');
      const panel = item.querySelector('[data-engraved-faq-panel]');

      if (!trigger || !panel) {
        return;
      }

      const setItemState = (isOpen) => {
        // 根据当前展开状态切换类名、无障碍属性和内容高度。
        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', String(isOpen));
        panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : '0px';
      };

      const toggleItem = () => {
        // 点击 FAQ 项时重新计算高度，保证展开动画逐渐展开。
        setItemState(!item.classList.contains('is-open'));
      };

      trigger.addEventListener('click', toggleItem);

      trigger.addEventListener('keydown', (event) => {
        // div 模拟按钮时，支持 Enter 和 Space 键展开/收起。
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        toggleItem();
      });
    });
  });

  window.addEventListener('resize', () => {
    // 视窗尺寸变化后，更新已展开内容的高度，避免文字换行导致高度不准。
    document.querySelectorAll('.engraved-page-faq__item.is-open [data-engraved-faq-panel]').forEach((panel) => {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    });
  });
});
